import { Directive, HostListener, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { CoreState, UiInteraction, UiInteractionAction } from "@obg/ngx.core";

@Directive({
	selector: "[obgInteraction]",
})
export class UiInteractionDirective {
	@Input() obgInteraction: UiInteraction | undefined;

	constructor(
		private store: Store<CoreState>,
		private uiInteractionAction: UiInteractionAction
	) {}

	@HostListener("click")
	dispatchInteraction() {
		if (this.obgInteraction) {
			this.store.dispatch(this.uiInteractionAction.emit(this.obgInteraction));
		}
	}
}
